import { PropsWithChildren } from 'react';
import { CircularProgressProps } from '@mui/material/CircularProgress';
import {
  StyledProgressBadge,
  StyledCheckIcon,
  StyledIconWrapper,
  StyledIconProgressIconContainer,
  StyledCircularProgress,
} from './styles';

export interface IconProgressProps
  extends Omit<CircularProgressProps, 'color'> {
  enableAvatarView?: boolean;
  opacity?: number;
  color?: string;
  backgroundRGBColor?: string;
}

export default function IconProgress(
  props: PropsWithChildren<IconProgressProps>,
) {
  const {
    color,
    backgroundRGBColor,
    children,
    value = 0,
    enableAvatarView = false,
    opacity = 1,
    ...iconProgressProps
  } = props;

  return (
    <StyledProgressBadge
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      badgeContent={value === 100 ? <StyledCheckIcon /> : null}
      color="success"
      enableAvatarView={enableAvatarView}
    >
      <StyledIconWrapper
        enableAvatarView={enableAvatarView}
        backgroundRGBColor={backgroundRGBColor}
        opacity={opacity}
      >
        <StyledIconProgressIconContainer
          enableAvatarView={enableAvatarView}
          color={color}
        >
          {children}
        </StyledIconProgressIconContainer>
      </StyledIconWrapper>

      <StyledCircularProgress
        variant="determinate"
        value={value}
        size="100%"
        thickness={2}
        {...iconProgressProps}
      />
    </StyledProgressBadge>
  );
}
